import RegisterFormPremium from './RegisterFormPremium';

export default RegisterFormPremium;
